var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsaSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1189_233",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1189_233)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H32V24H0V0Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.6665V16.6665H32V14.6665H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18.3335V20.3335H32V18.3335H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.3335V9.3335H32V7.3335H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 22V24H32V22H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11V13H32V11H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V2H32V0H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.6665V5.6665H32V3.6665H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 13,
    fill: "#2E42A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.72319 2.93871L0.997308 3.44759L1.24237 2.54198L0.597656 1.96807H1.43974L1.72217 1.229L2.05334 1.96807H2.7712L2.20716 2.54198L2.42553 3.44759L1.72319 2.93871ZM5.72319 2.93871L4.99731 3.44759L5.24237 2.54198L4.59766 1.96807H5.43974L5.72217 1.229L6.05334 1.96807H6.7712L6.20716 2.54198L6.42553 3.44759L5.72319 2.93871ZM8.99731 3.44759L9.72319 2.93871L10.4255 3.44759L10.2072 2.54198L10.7712 1.96807H10.0533L9.72217 1.229L9.43974 1.96807H8.59766L9.24237 2.54198L8.99731 3.44759ZM13.7232 2.93871L12.9973 3.44759L13.2424 2.54198L12.5977 1.96807H13.4397L13.7222 1.229L14.0533 1.96807H14.7712L14.2072 2.54198L14.4255 3.44759L13.7232 2.93871ZM0.997308 7.44759L1.72319 6.93871L2.42553 7.44759L2.20716 6.54198L2.7712 5.96807H2.05334L1.72217 5.229L1.43974 5.96807H0.597656L1.24237 6.54198L0.997308 7.44759ZM5.72319 6.93871L4.99731 7.44759L5.24237 6.54198L4.59766 5.96807H5.43974L5.72217 5.229L6.05334 5.96807H6.7712L6.20716 6.54198L6.42553 7.44759L5.72319 6.93871ZM8.99731 7.44759L9.72319 6.93871L10.4255 7.44759L10.2072 6.54198L10.7712 5.96807H10.0533L9.72217 5.229L9.43974 5.96807H8.59766L9.24237 6.54198L8.99731 7.44759ZM13.7232 6.93871L12.9973 7.44759L13.2424 6.54198L12.5977 5.96807H13.4397L13.7222 5.229L14.0533 5.96807H14.7712L14.2072 6.54198L14.4255 7.44759L13.7232 6.93871ZM0.997308 11.4476L1.72319 10.9387L2.42553 11.4476L2.20716 10.542L2.7712 9.96807H2.05334L1.72217 9.229L1.43974 9.96807H0.597656L1.24237 10.542L0.997308 11.4476ZM5.72319 10.9387L4.99731 11.4476L5.24237 10.542L4.59766 9.96807H5.43974L5.72217 9.229L6.05334 9.96807H6.7712L6.20716 10.542L6.42553 11.4476L5.72319 10.9387ZM8.99731 11.4476L9.72319 10.9387L10.4255 11.4476L10.2072 10.542L10.7712 9.96807H10.0533L9.72217 9.229L9.43974 9.96807H8.59766L9.24237 10.542L8.99731 11.4476ZM13.7232 10.9387L12.9973 11.4476L13.2424 10.542L12.5977 9.96807H13.4397L13.7222 9.229L14.0533 9.96807H14.7712L14.2072 10.542L14.4255 11.4476L13.7232 10.9387ZM16.9973 3.44759L17.7232 2.93871L18.4255 3.44759L18.2072 2.54198L18.7712 1.96807H18.0533L17.7222 1.229L17.4397 1.96807H16.5977L17.2424 2.54198L16.9973 3.44759ZM17.7232 6.93871L16.9973 7.44759L17.2424 6.54198L16.5977 5.96807H17.4397L17.7222 5.229L18.0533 5.96807H18.7712L18.2072 6.54198L18.4255 7.44759L17.7232 6.93871ZM16.9973 11.4476L17.7232 10.9387L18.4255 11.4476L18.2072 10.542L18.7712 9.96807H18.0533L17.7222 9.229L17.4397 9.96807H16.5977L17.2424 10.542L16.9973 11.4476ZM3.72319 4.93871L2.99731 5.44759L3.24237 4.54198L2.59766 3.96807H3.43974L3.72217 3.229L4.05334 3.96807H4.7712L4.20716 4.54198L4.42553 5.44759L3.72319 4.93871ZM6.99731 5.44759L7.72319 4.93871L8.42553 5.44759L8.20716 4.54198L8.7712 3.96807H8.05334L7.72217 3.229L7.43974 3.96807H6.59766L7.24237 4.54198L6.99731 5.44759ZM11.7232 4.93871L10.9973 5.44759L11.2424 4.54198L10.5977 3.96807H11.4397L11.7222 3.229L12.0533 3.96807H12.7712L12.2072 4.54198L12.4255 5.44759L11.7232 4.93871ZM2.99731 9.44759L3.72319 8.93871L4.42553 9.44759L4.20716 8.54198L4.7712 7.96807H4.05334L3.72217 7.229L3.43974 7.96807H2.59766L3.24237 8.54198L2.99731 9.44759ZM7.72319 8.93871L6.99731 9.44759L7.24237 8.54198L6.59766 7.96807H7.43974L7.72217 7.229L8.05334 7.96807H8.7712L8.20716 8.54198L8.42553 9.44759L7.72319 8.93871ZM10.9973 9.44759L11.7232 8.93871L12.4255 9.44759L12.2072 8.54198L12.7712 7.96807H12.0533L11.7222 7.229L11.4397 7.96807H10.5977L11.2424 8.54198L10.9973 9.44759ZM15.7232 4.93871L14.9973 5.44759L15.2424 4.54198L14.5977 3.96807H15.4397L15.7222 3.229L16.0533 3.96807H16.7712L16.2072 4.54198L16.4255 5.44759L15.7232 4.93871ZM14.9973 9.44759L15.7232 8.93871L16.4255 9.44759L16.2072 8.54198L16.7712 7.96807H16.0533L15.7222 7.229L15.4397 7.96807H14.5977L15.2424 8.54198L14.9973 9.44759Z",
    fill: "#F7FCFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaSmall);
export default __webpack_public_path__ + "static/media/usa_small.6ddbbcae825f0ec2fc8fbf2c91ae58bb.svg";
export { ForwardRef as ReactComponent };